import React from 'react';
import { MatchingMode } from '../utils/matchingLogic';
import '../styles/GameTypeSelection.css';

interface GameTypeSelectionProps {
  onSelectType: (type: MatchingMode) => void;
  onBack: () => void;
}

const GameTypeSelection: React.FC<GameTypeSelectionProps> = ({ onSelectType, onBack }) => {
  return (
    <div className="game-type-selection">
      <button className="back-button-top" onClick={onBack}>
        ← Back
      </button>

      <h2 className="game-type-title">Choose Game Type</h2>
      <p className="game-type-subtitle">Select how you want to play</p>

      <div className="game-type-cards">
        <div
          className="game-type-card type-one-to-one"
          onClick={() => onSelectType('one-to-one')}
        >
          <div className="game-type-icon">🔄</div>
          <h3 className="game-type-name">Pair Match</h3>
          <p className="game-type-description">Match two items that belong together</p>
          <div className="game-type-example">
            <div className="example-label">Example:</div>
            <div className="example-content">cat ↔ 🐱</div>
          </div>
        </div>

        <div
          className="game-type-card type-category"
          onClick={() => onSelectType('category')}
        >
          <div className="game-type-icon">📂</div>
          <h3 className="game-type-name">Pair & Classify</h3>
          <p className="game-type-description">Match two items and their category</p>
          <div className="game-type-example">
            <div className="example-label">Example:</div>
            <div className="example-content">Paris + Lyon → France</div>
          </div>
        </div>

        <div
          className="game-type-card type-sort"
          onClick={() => onSelectType('sort')}
        >
          <div className="game-type-icon">🏷️</div>
          <h3 className="game-type-name">Sort & Classify</h3>
          <p className="game-type-description">Drag items one-by-one to correct category labels</p>
          <div className="game-type-example">
            <div className="example-label">Example:</div>
            <div className="example-content">China → Asia</div>
          </div>
        </div>

        <div
          className="game-type-card type-multiple-choice"
          onClick={() => onSelectType('multiple-choice')}
        >
          <div className="game-type-icon">❓</div>
          <h3 className="game-type-name">Multiple Choice</h3>
          <p className="game-type-description">Answer vocabulary questions with 4 options</p>
          <div className="game-type-example">
            <div className="example-label">Example:</div>
            <div className="example-content">你好 → Hello</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameTypeSelection;
